'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"

export default {
  async getBrands(params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)
    if (params.all) query.set('all', 1)

    const response = await api.api({
      method: 'get',
      url: `brands${query.toString() ? `?${query.toString()}` : ''}`,
    })
    if (response.status === 200) {
      return response.data
    }
  },
  async getBrand(id) {
    const response = await api.api({ method: 'get', url: 'brand/' + id })
    if (response.status === 200) {
      return response.data
    }
  },
  async createBrand(json) {
    const response = await api.api({ method: 'post', url: 'brand', body: json })
    if (response.status === 201) {
      notify.alert.success('Brand created successfully')
      return response.data
    }
  },
  async updateBrand(json, id) {
    const response = await api.api({ method: 'put', url: 'brand/' + id, body: json })
    if (response.status === 200) {
      notify.alert.success('Brand updated successfully')
      return response.data
    }
  },
  async deleteBrand(id) {
    const response = await api.api({ method: 'delete', url: 'brand/' + id })
    if (response.status === 200) {
      notify.alert.success('Brand deleted successfully')
      return true
    }
  },
  async getBrandProducts(id, params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    const response = await api.api({
      method: 'get',
      url: `brand/${id}/products${query.toString() ? `?${query.toString()}` : ''}`,
    })
    if (response.status === 200) {
      return response.data
    }
  },
}
